import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('INSTRUMENTALS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class InstrumentalsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'instrumentals' como el nombre del recurso a la clase base
    super('instrumentals');
    log.debug('Servicio de Instrumental inicializado');
  }

}
